import {devLogger} from "../util/loggingUtils";

export interface Config {
    paymentEdgeHost: string,
    directPostProxy: string
    pnsPropertyId: string | undefined,
    nwPropertyId: string | undefined,
    gaUrl: string | undefined,
    isDevelopment: boolean,
    appVersion: string,
    gitHash: string,
    cardStatusDelay: number,
    pnsRedirectUrl: string | undefined,
    nwRedirectUrl: string | undefined,
    whiteListedDomains: object,
    pnsReturnUrlFailureUrl: string,
    nwReturnUrlFailureUrl: string,
    whiteListedDeepLinks: object,
    pnsReturnUrlFailureDeepLink: string,
    nwReturnUrlFailureDeepLink: string

}

let config: Config;
const nonProdDefaultDeeplinkWhitelist = [
    "newworld-dev://",
    "paknsave-dev://",
    "newworld-test://",
    "paknsave-test://",
    "newworld://",
    "paknsave://"
]
export const initialiseConfig = () => {
    config = {
        // Rest of the config
        paymentEdgeHost: window?._env_?.PAYMENT_API_URL || 'payment-api.local.test',
        directPostProxy: window?._env_?.DIRECT_POST_PROXY ?? "",
        pnsPropertyId: window?._env_?.GA_PROPERTY_PNS,
        nwPropertyId: window?._env_?.GA_PROPERTY_NW,
        gaUrl: window?._env_?.GA_URL,
        isDevelopment: process.env.NODE_ENV === "development",
        appVersion: process.env.REACT_APP_VERSION,
        gitHash: process.env.REACT_APP_GIT_HASH,
        cardStatusDelay: 4000,
        // Sitecore hardcoded redirects
        pnsRedirectUrl: window?._env_?.REDIRECT_URL_PNS,
        nwRedirectUrl: window?._env_?.REDIRECT_URL_NW,
        // Website domain whitelist, not env specific so set here
        whiteListedDomains: ["paknsave.co.nz", "newworld.co.nz"],
        // Website hardcoded returnUrl whitelist failure pages
        pnsReturnUrlFailureUrl: window?._env_?.WEBSITE_RETURN_URL_FAILURE_PAGE_PNS || "https://test.paknsave.co.nz/failure-page",
        nwReturnUrlFailureUrl: window?._env_?.WEBSITE_RETURN_URL_FAILURE_PAGE_NW || "https://test.newworld.co.nz/failure-page",
        // Mobile app deep link whitelist
        whiteListedDeepLinks: window?._env_?.WHITE_LISTED_DEEP_LINKS ||  nonProdDefaultDeeplinkWhitelist,
        // Mobile app hardcoded returnUrl whitelist failure pages
        pnsReturnUrlFailureDeepLink: window?._env_?.MOBILE_APP_RETURN_DEEP_LINK_FAILURE_PAGE_PNS || "packnsave://",
        nwReturnUrlFailureDeepLink: window?._env_?.MOBILE_APP_RETURN_DEEP_LINK_FAILURE_PAGE_NW || "newworld://"
    } as Config;
    if (config.isDevelopment) {
        devLogger("Current config: ");
        devLogger(JSON.stringify(config));
    }
}

export const getConfiguration = () : Config => {
    if (!config) {
        initialiseConfig();
    }
    return config;
}